import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useNotification } from '../../../../../hooks'
import { ConfirmationModal } from '../../../../Confirmation'
import { REQUEST_PROFILE_TAB_INTERNAL_TASKS_NOTIFICATION_TITLE_KEY } from '../../RequestProfileTabInternalTasks.constants'
import { useRequestProfileTabInternalTasksContext } from '../useRequestProfileTabInternalTasksContext'

export function useRequestProfileTabInternalTasksChecklistActions(checklist) {
  const { t } = useTranslation()

  const {
    handleAddChecklistItem,
    handleDeleteChecklist,
    setModal,
    onCloseModal,
  } = useRequestProfileTabInternalTasksContext()

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  const [isAddingChecklistItem, setAddingChecklistItem] = useState(false)

  const [isAddChecklistItemLoading, setAddChecklistItemLoading] =
    useState(false)

  async function handleConfirmDelete() {
    return handleDeleteChecklist(checklist.id)
      .then(() => {
        onCloseModal()
        handleAddSuccessNotification(
          REQUEST_PROFILE_TAB_INTERNAL_TASKS_NOTIFICATION_TITLE_KEY.listDeleted
        )
      })
      .catch(() => {
        handleAddErrorNotification('Error.CommonApiRequestFailKey')
      })
  }

  function handleOpenDeleteModal() {
    setModal(
      <ConfirmationModal
        actionButtonsProps={{
          submitText: t('Modal.DeleteBtnKey'),
        }}
        description={t('RequestProfile.InternalTasksDeleteListDescriptionKey')}
        title={t('RequestProfile.InternalTasksDeleteListTitleKey')}
        onCancel={onCloseModal}
        onSubmit={handleConfirmDelete}
      />
    )
  }

  function handleShowAddChecklistItem() {
    setAddingChecklistItem(true)
  }

  function handleCancelAddChecklistItem() {
    setAddingChecklistItem(false)
  }

  async function handleSubmitAddChecklistItem(text) {
    setAddChecklistItemLoading(true)

    return handleAddChecklistItem(checklist.id, text)
      .then(() => {
        setAddingChecklistItem(false)
        handleAddSuccessNotification(
          REQUEST_PROFILE_TAB_INTERNAL_TASKS_NOTIFICATION_TITLE_KEY.taskAdded
        )
      })
      .catch(() => {
        handleAddErrorNotification('Error.CommonApiRequestFailKey')
      })
      .finally(() => {
        setAddChecklistItemLoading(false)
      })
  }

  return {
    handleCancelAddChecklistItem,
    handleOpenDeleteModal,
    handleShowAddChecklistItem,
    handleSubmitAddChecklistItem,
    isAddChecklistItemLoading,
    isAddingChecklistItem,
  }
}
